import { useEffect } from "react";
import {
  resolveToolGuideRows,
  ToolGuideKind,
} from "src/domains/shared/utils/toolGuideMessage";
import {
  NO_TOOL_GUIDE,
  ToolGuideState,
  useControlSection,
} from "./layout/ControlSection";

export function resolveToolGuide(
  kind: ToolGuideKind,
  pointCount: number
): ToolGuideState {
  return { rows: resolveToolGuideRows(kind, pointCount) };
}

interface UseToolGuideOptions {
  isActive: boolean;
  kind: ToolGuideKind;
  pointCount: number;
}

/**
 * 활성 도구의 단계 줄 목록을 `ControlSection` 안내 슬롯에 올리고, 비활성 전이 시 비운다.
 * 그리기 버튼 6개와 `DroneImagePicker` 가 쓴다 — 그리기 전용이 아니다.
 * `ControlSection` 컨텍스트에 기대므로 **2D 지도 안에서만** 살 수 있다(3D 는 `use3DToolGuide`).
 */
export function useToolGuide({
  isActive,
  kind,
  pointCount,
}: UseToolGuideOptions) {
  const { setToolGuide } = useControlSection();

  useEffect(() => {
    if (!isActive) return;
    setToolGuide(resolveToolGuide(kind, pointCount));
    return () => setToolGuide(NO_TOOL_GUIDE);
  }, [isActive, kind, pointCount, setToolGuide]);
}
